import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { NgClass } from '@angular/common';
import { IconButtonComponent } from '@shared/components/ui/icon-button';
import { TranslateModule } from '@ngx-translate/core';
import { SystemIconsComponent } from '@shared/components/ui/system-icons';

type TType = 'light' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'purple' | 'pink' | 'orange' | 'lime' | 'emerald' | 'cyan';
@Component({
  selector: 'lib-text-alert',
  imports: [NgClass, IconButtonComponent, TranslateModule, SystemIconsComponent],
  templateUrl: './text-alert.component.html',
  styleUrl: './text-alert.component.css',
})
export class TextAlertComponent {
  public readonly text: InputSignal<string> = input();
  public readonly title: InputSignal<string> = input();
  public readonly type: InputSignal<TType> = input<TType>('light');
  public readonly icon: InputSignal<string> = input();
  public readonly systemIcon: InputSignal<string> = input();
  public readonly iconButton: InputSignal<string> = input();
  public readonly link: InputSignal<{ text: string; url: string }> = input();
  public readonly buttonClicked: OutputEmitterRef<void> = output();
}
